<template>
    <main class="login-page flex">
        <ul class="PersonalCabinet__errors"></ul>
        <form class="login-form" action="/register" method="post">

            <h2> {{ trans('Registration') }} </h2>
            <div class="login-form__content">
                <div class="input-wrapper">
                    <span class="input-wrapper__title">{{ trans("Name") }}, {{ trans("surname") }}</span>

                    <input v-model="name" id="name" type="text" class="input-element input-wrapper__element-inp "
                           name="name"
                           required="" autocomplete="name" autofocus="">

                </div>
                <div class="input-wrapper">
                    <span class="input-wrapper__title">EMAIL</span>

                    <input v-model="email" id="email" placeholder="john-wick@gmail.com" type="email"
                           class="input-element input-wrapper__element-inp " name="email" required=""
                           autocomplete="email">


                </div>
                <div class="input-wrapper">
                    <span class="input-wrapper__title">{{ trans("Password") }}</span>
                    <input v-model="password" id="password" type="password"
                           class="input-element input-wrapper__element-inp "
                           name="password" required="" autocomplete="new-password">

                </div>
                <div class="input-wrapper">
                    <span class="input-wrapper__title">{{ trans("Confirm the password") }}</span>
                    <input v-model="password_confirmation" id="password-confirm" type="password"
                           class="input-element input-wrapper__element-inp "
                           name="password_confirmation" required="" autocomplete="new-password">


                </div>
                <div class="login-form__checkboxes">
                    <div class="input-wrapper login-form__checkbox-wrapper">
                        <label class="input-wrapper__title input-checkbox__wrapper login-form__checkbox-title">
                            <input v-model="terms_accepted" required="" type="checkbox" class="input-checkbox"
                                   name="terms_accepted">
                            <span> {{ trans("I accept") }}
                                        <a href="/privacy-policy"
                                                     class="login-form__secondary-link">{{
                                                trans("privacy policy")
                                            }}</a>
                            </span>
                        </label>
                    </div>
                    <div class="input-wrapper login-form__checkbox-wrapper">
                        <label class="input-wrapper__title input-checkbox__wrapper login-form__checkbox-title">
                            <input v-model="subscribe" type="checkbox" class="input-checkbox" name="subscription">
                            <span> {{ trans("Leave us your email address and stay informed about our discounts and special offers") }} </span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="login-form__footer">
                <button type="submit" class="btn btnV2" > {{ trans("Registration") }}</button>
                <a href="/login" class="login-form__link user-account__big-text-line">
                    {{ trans("Enter") }} </a>
            </div>

            <SOCIAL/>
        </form>
    </main>
</template>

<script>
import SOCIAL from "./social-lite.vue"

export default {
    components: {
        SOCIAL
    },
    name: "register",
    data() {
        return {
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            terms_accepted: true,
            subscribe: true,
            error_message: false,

        }
    },
    mounted() {

    },
    methods: {
        getUser() {
            axios.get('/api/v1/get-user', {
                params: {
                    email: this.email,
                }


            }).then(data => {

                this.$store.state.settings.user = data.data
                this.updateStorage(this.$store.state.settings)
            }).then(r => {

                this.$router.push({name: 'personal'})
            }).catch(err => {
                this.$router.push({name: 'login'})
            })


        },
        validateEmail(email) {
            const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
            if(emailRegex.test(email)){
                return true
            }else {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Incorrect email address'),
                    type: 'error',
                });
            }
        },
        loginValidate() {

                this.error_message = false
                if (this.name === '') {
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans("Fill in all the fields"),
                        type: 'error',
                    });
                    this.error_message = true
                }
                if (this.password === '') {
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans("Fill in all the fields"),
                        type: 'error',
                    });
                    this.error_message = true
                }

                if (this.password.length < 6) {
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans("The password is at least 6 characters long"),
                        type: 'error',
                    });
                    this.error_message = true
                }
                if (this.password !== this.password_confirmation) {
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans("The password does not match"),
                        type: 'error',
                    });
                    this.error_message = true
                }
                if (this.error_message) {
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans("Fill in all the fields"),
                        type: 'error',
                    });
                    return false
                } else {
                    return true;
                }



        },
        register() {

            if ( this.loginValidate() && this.validateEmail(this.email)) {
                axios.get('/sanctum/csrf-cookie').then(response => {
                    axios.post('/register', {
                        name: this.name,
                        email: this.email,
                        password: this.password,
                        password_confirmation: this.password_confirmation,
                    }).then(r => {

                        localStorage.setItem('csrf_token', r.config.headers['X-CSRF-TOKEN'])


                    }).then(this.getUser).catch(err => {

                        this.$notify({
                            title: this.trans('Error'),
                            text: this.trans(err.response.data.message),
                            type: 'error',
                        });
                    })
                });
            } else {

            }


        }
    }
}
</script>

<style scoped>
.login-page {
    margin: 0 auto;
}
</style>
